/* Collection quickfilters horizontal scroll + arrows
   Lightweight helper: finds [data-quickfilters] wrappers and wires arrows + visibility
   Now specifically designed for brand filters only with configurable order
*/
(function () {
  function initQuickFilters(wrapper) {
    var scroller = wrapper.querySelector('.CollectionToolbar__QuickFilters');
    var btnPrev = wrapper.querySelector('.QuickFilters__Arrow--prev');
    var btnNext = wrapper.querySelector('.QuickFilters__Arrow--next');

    if (!scroller || !btnPrev || !btnNext) return;

    var scrollAmount = Math.max(Math.round(scroller.clientWidth * 0.6), 120);

    function updateArrows() {
      var maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
      
      // Hide both arrows if content doesn't overflow (no scrolling needed)
      if (maxScrollLeft <= 1) {
        btnPrev.classList.add('is-hidden');
        btnNext.classList.add('is-hidden');
        // Center the filters when they don't overflow
        scroller.classList.add('centered');
        return;
      }
      
      // Remove centering when scrolling is available (prevents cut-off)
      scroller.classList.remove('centered');
      
      // Normal edge-based visibility when scrolling is available
      if (scroller.scrollLeft <= 1) {
        btnPrev.classList.add('is-hidden');
      } else {
        btnPrev.classList.remove('is-hidden');
      }
      if (scroller.scrollLeft >= maxScrollLeft - 1) {
        btnNext.classList.add('is-hidden');
      } else {
        btnNext.classList.remove('is-hidden');
      }
    }

    // mark wrapper so we can style or detect it in the DOM and help debugging
    wrapper.classList.add('quickfilters-initialized');

    // Debug: log sizes so we can see why arrows may be hidden
    try {
      console.log('[QuickFilters] init', {
        scrollerClientWidth: scroller.clientWidth,
        scrollerScrollWidth: scroller.scrollWidth,
        scrollAmount: scrollAmount
      });
    } catch (e) { }

    // per-item scrolling: move to the next/previous quicklink element
    function scrollToElement(el) {
      if (!el) return;
      var maxScrollLeft = Math.max(scroller.scrollWidth - scroller.clientWidth, 0);
      // align the element to the left edge of the scroller with small padding
      var padding = 8;
      var target = Math.min(Math.max(el.offsetLeft - padding, 0), maxScrollLeft);
      scroller.scrollTo({ left: target, behavior: 'smooth' });
    }

    // compute visible item index range (first..last) within the scroller viewport
    function getVisibleRange() {
      var items = scroller.querySelectorAll('.CollectionToolbar__Item--quicklink');
      if (!items || items.length === 0) return null;
      var visibleLeft = scroller.scrollLeft;
      var visibleRight = visibleLeft + scroller.clientWidth;
      var first = -1, last = -1;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var itLeft = it.offsetLeft;
        var itRight = itLeft + it.offsetWidth;
        // intersects viewport?
        if (itRight > visibleLeft + 1 && itLeft < visibleRight - 1) {
          if (first === -1) first = i;
          last = i;
        }
      }
      return { items: items, first: first, last: last };
    }

    btnPrev.addEventListener('click', function () {
      var range = getVisibleRange();
      if (range && range.first > 0) {
        scrollToElement(range.items[range.first - 1]);
        return;
      }
      // fallback: small chunk if no items found or already at start
      var amount = Math.max(Math.round(scroller.clientWidth * 0.3), 80);
      scroller.scrollTo({ left: Math.max(scroller.scrollLeft - amount, 0), behavior: 'smooth' });
    });

    btnNext.addEventListener('click', function () {
      var range = getVisibleRange();
      if (range && range.last >= 0 && range.last < range.items.length - 1) {
        scrollToElement(range.items[range.last + 1]);
        return;
      }
      // fallback: small chunk if no items found or already at end
      var amount = Math.max(Math.round(scroller.clientWidth * 0.3), 80);
      var maxScrollLeft = Math.max(scroller.scrollWidth - scroller.clientWidth, 0);
      scroller.scrollTo({ left: Math.min(scroller.scrollLeft + amount, maxScrollLeft), behavior: 'smooth' });
    });

    scroller.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        var range = getVisibleRange();
        if (range && range.first > 0) {
          scrollToElement(range.items[range.first - 1]);
        } else {
          scroller.scrollBy({ left: -80, behavior: 'smooth' });
        }
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        var range = getVisibleRange();
        if (range && range.last >= 0 && range.last < range.items.length - 1) {
          scrollToElement(range.items[range.last + 1]);
        } else {
          scroller.scrollBy({ left: 80, behavior: 'smooth' });
        }
      }
    });

    scroller.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrows);
    });

    var ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(function () {
      scrollAmount = Math.max(Math.round(scroller.clientWidth * 0.6), 120);
      updateArrows();
    }) : null;

    if (ro) ro.observe(scroller);

    // initial
    updateArrows();

    // listen for external refresh events
    wrapper.addEventListener('quickfilters:refresh', function () {
      try { scrollAmount = Math.max(Math.round(scroller.clientWidth * 0.6), 120); updateArrows(); } catch (e) { }
    });
  }

  function initAll() {
    var wrappers = document.querySelectorAll('[data-quickfilters]');
    wrappers.forEach(initQuickFilters);
    // Also schedule a couple of retries in case the content is updated later
    setTimeout(function () { wrappers.forEach(function (w) { var ev = new CustomEvent('quickfilters:refresh'); w.dispatchEvent(ev); }); }, 250);
    setTimeout(function () { wrappers.forEach(function (w) { var ev = new CustomEvent('quickfilters:refresh'); w.dispatchEvent(ev); }); }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

/* ------------------------------------------------------------------
   Collection filter drawer fallback
   - Keeps the mobile Filters button working even if broader theme drawer
   delegation is skipped by collection-specific customizations.
   ------------------------------------------------------------------ */
(function () {
  if (window.__collectionFilterDrawerFallbackInitialized) return;
  window.__collectionFilterDrawerFallbackInitialized = true;

  var DRAWER_ID = 'collection-filter-drawer';
  var OPEN_SELECTOR = '[data-action="open-drawer"][data-drawer-id="' + DRAWER_ID + '"]';
  var CLOSE_SELECTOR = '[data-action="close-drawer"][data-drawer-id="' + DRAWER_ID + '"]';

  function getDrawer() {
    return document.getElementById(DRAWER_ID);
  }

  function getOverlay() {
    return document.querySelector('.PageOverlay');
  }

  function isOpen(drawer) {
    return !!drawer && drawer.getAttribute('aria-hidden') === 'false';
  }

  function openDrawer(event) {
    var drawer = getDrawer();
    if (!drawer) return;

    if (event && typeof event.preventDefault === 'function') event.preventDefault();

    drawer.setAttribute('aria-hidden', 'false');
    drawer.style.maxHeight = window.innerHeight + 'px';
    document.documentElement.classList.add('no-scroll');

    var overlay = getOverlay();
    if (overlay) overlay.classList.add('is-visible');
  }

  function closeDrawer(event) {
    var drawer = getDrawer();
    if (!drawer) return;

    if (event && typeof event.preventDefault === 'function') event.preventDefault();

    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');

    var overlay = getOverlay();
    if (overlay) overlay.classList.remove('is-visible');
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target && event.target.closest ? event.target.closest(OPEN_SELECTOR) : null;
    if (openTrigger) {
      openDrawer(event);
      return;
    }

    var closeTrigger = event.target && event.target.closest ? event.target.closest(CLOSE_SELECTOR) : null;
    if (closeTrigger) {
      closeDrawer(event);
      return;
    }

    var overlay = getOverlay();
    if (overlay && event.target === overlay && isOpen(getDrawer())) {
      closeDrawer(event);
    }
  });

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape' && isOpen(getDrawer())) {
      closeDrawer();
    }
  });

  window.addEventListener('resize', function () {
    var drawer = getDrawer();
    if (isOpen(drawer)) {
      drawer.style.maxHeight = window.innerHeight + 'px';
    }
  });
})();

/* ------------------------------------------------------------------
   Results count updater
   - Updates any `.CollectionToolbar__Results` text to reflect the number
     of rendered product tiles after page load and when the product list
     is modified (e.g. after AJAX filter/sort reloads).
   - Uses MutationObserver with a small debounce; falls back to a timed
     retry if MutationObserver isn't available.
   ------------------------------------------------------------------ */
(function () {
  if (window.__resultsCountUpdaterInitialized) return; window.__resultsCountUpdaterInitialized = true;

  function pluralize(n) { return n === 1 ? 'Result' : 'Results'; }

  function countProductTiles() {
    // primary: find product list container and count product cells
    var selectors = [
      '.CollectionInner__Products .ProductList .Grid__Cell',
      '.ProductList .Grid__Cell',
      '.ProductListWrapper .Grid__Cell',
      '.ProductList .ProductList__Item',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var els = document.querySelectorAll(selectors[i]);
      if (els && els.length) return els.length;
    }
    // fallback: try pagination total if present
    try {
      var pag = document.querySelector('.Pagination');
      if (pag) {
        var totalEl = pag.querySelector('[data-total]');
        if (totalEl && totalEl.getAttribute('data-total')) return parseInt(totalEl.getAttribute('data-total'), 10) || 0;
      }
    } catch (e) { }
    return 0;
  }

  function updateResultsText() {
    try {
      var n = countProductTiles();
      var nodes = document.querySelectorAll('.CollectionToolbar__Results');
      nodes.forEach(function (el) {
        // preserve any leading/trailing whitespace but replace content
        el.textContent = n + ' ' + pluralize(n);
      });
    } catch (e) { /* swallow */ }
  }

  // debounce helper
  function debounce(fn, wait) {
    var t = null;
    return function () { clearTimeout(t); t = setTimeout(fn, wait || 120); };
  }

  var debouncedUpdate = debounce(updateResultsText, 120);

  function observeProductArea() {
    var root = document.querySelector('.CollectionInner__Products') || document.body;
    if (typeof MutationObserver === 'undefined') {
      // fallback: periodic check for a short time
      var checks = 0; var max = 20;
      var iv = setInterval(function () { updateResultsText(); checks++; if (checks >= max) clearInterval(iv); }, 250);
      return;
    }
    try {
      var mo = new MutationObserver(function (mutations) {
        var relevant = false;
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'childList' || m.type === 'subtree' || m.type === 'attributes') { relevant = true; break; }
        }
        if (relevant) debouncedUpdate();
      });
      mo.observe(root, { childList: true, subtree: true, attributes: false });
      // Keep observation for the session; update initially as well
    } catch (e) {
      // fallback periodic
      var checks2 = 0; var max2 = 20;
      var iv2 = setInterval(function () { updateResultsText(); checks2++; if (checks2 >= max2) clearInterval(iv2); }, 250);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { updateResultsText(); observeProductArea(); }); else { updateResultsText(); observeProductArea(); }

  // Also listen for a common custom event used to signal product reloads
  document.addEventListener('products:reloaded', function () { setTimeout(updateResultsText, 80); });

})();


(function () {
  function FilterController(section) {
    this.section = section || null; // expected CollectionSection instance
    this.ids = {
      drawer: 'collection-filters-drawer-form',
      sidebar: 'collection-filters-sidebar-form',
      quick: null
    };
    this._listeningForms = [];
    this._boundFormChangeListener = this._handleFormChange.bind(this);

    this._scan();
    this._attachListeners();
  }

  FilterController.prototype._scan = function () {
    this.formDrawer = document.getElementById(this.ids.drawer);
    this.formSidebar = document.getElementById(this.ids.sidebar);
    this.formQuick = null; // quicklinks are now standalone buttons, not a form

    // Prioritize visible form
    if (this.formSidebar && this.formSidebar.offsetParent !== null) {
      this._canonicalForm = this.formSidebar;
    } else if (this.formDrawer) {
      this._canonicalForm = this.formDrawer;
    } else {
      this._canonicalForm = this.formSidebar || this.formDrawer || this.formQuick || null;
    }
  };

  FilterController.prototype._handleFormChange = function () {
    try { this.syncQuickLinkUIFromForms(); } catch (e) { }
  };

  FilterController.prototype._detachListeners = function () {
    var listener = this._boundFormChangeListener;
    (this._listeningForms || []).forEach(function (form) {
      if (!form) return;
      form.removeEventListener('change', listener);
    });
    this._listeningForms = [];
  };

  FilterController.prototype._attachListeners = function () {
    var listener = this._boundFormChangeListener;

    this._scan();
    this._detachListeners();

    [this.formDrawer, this.formSidebar, this.formQuick].forEach(function (form) {
      if (!form) return;
      form.addEventListener('change', listener, { passive: true });
      this._listeningForms.push(form);
    }, this);
  };

  FilterController.prototype.serialize = function () {
    if (!this._canonicalForm) return '';
    try { return new URLSearchParams(new FormData(this._canonicalForm)).toString(); } catch (e) { return ''; }
  };

  FilterController.prototype.syncQuickLinkUIFromForms = function () {
    this._scan();
    var form = this._canonicalForm;
    if (!form) return;
    var quickContainer = document.querySelector('[data-quickfilters]');
    if (!quickContainer) return;

    var inputs = form.querySelectorAll('[name^="filter."]');
    var active = new Set();
    inputs.forEach(function (input) {
      if ((input.type === 'checkbox' || input.type === 'radio') && input.checked) active.add(input.name + '=' + input.value);
      else if (input.tagName === 'SELECT' && input.value) active.add(input.name + '=' + input.value);
    });

    var quickLinks = quickContainer.querySelectorAll('.CollectionToolbar__Item--quicklink, label.CollectionToolbar__Item--quicklink, button.CollectionToolbar__Item--quicklink');
    quickLinks.forEach(function (link) {
      var param = link.getAttribute('data-filter-param') || link.getAttribute('data-param');
      var value = link.getAttribute('data-filter-value') || link.getAttribute('data-value');
      if ((!param || !value) && link.hasAttribute('for')) {
        var fid = link.getAttribute('for');
        var inp = form.querySelector('#' + cssEscape(fid)) || document.getElementById(fid);
        if (inp) {
          var has = (inp.type === 'checkbox' || inp.type === 'radio') ? inp.checked : (inp.value && active.has(inp.name + '=' + inp.value));
          link.classList.toggle('is-selected', !!has);
          link.setAttribute('aria-pressed', has ? 'true' : 'false');
          return;
        }
      }
      if (!param || !value) return;
      var key = param + '=' + value;
      if (active.has(key)) { link.classList.add('is-selected'); link.setAttribute('aria-pressed', 'true'); }
      else { link.classList.remove('is-selected'); link.setAttribute('aria-pressed', 'false'); }
    });
  };

  FilterController.prototype.toggleByParam = function (paramName, value) {
    this._scan();
    var found = null;
    var selector = '[name="' + cssEscape(paramName) + '"][value="' + cssEscape(value) + '"]';
    [this.formDrawer, this.formSidebar, this.formQuick].forEach(function (form) {
      if (!form) return;
      var input = form.querySelector(selector);
      if (input) {
        if (input.type === 'checkbox') input.checked = !input.checked; else if (input.type === 'radio') input.checked = true; else input.value = input.value === value ? '' : value;
        found = input;
        var event = new Event('change', { bubbles: true });
        input.dispatchEvent(event);
      }
    });
    this.syncQuickLinkUIFromForms();
    return !!found;
  };

  FilterController.prototype.syncAndReload = function (options) {
    options = options || {};
    var queryString = this.serialize();
    var path = window.location.pathname + (queryString ? ('?' + queryString) : '');
    if (this.section && typeof this.section._reloadProducts === 'function') this.section._reloadProducts(path, options); else { if (options.pushState === false) window.history.replaceState({ path: path }, '', path); else window.location.href = path; }
  };

  FilterController.prototype.refresh = function () {
    this._attachListeners();
    this.syncQuickLinkUIFromForms();
    var wrappers = document.querySelectorAll('[data-quickfilters]'); wrappers.forEach(function (w) { w.dispatchEvent(new CustomEvent('quickfilters:refresh')); });
  };

  /**
   * Clear all filter inputs in the canonical form (drawer/sidebar) and
   * update quicklinks UI accordingly, then trigger a single reload.
   * options are forwarded to syncAndReload (e.g. { pushState: false })
   */
  FilterController.prototype.clearAll = function (options) {
    options = options || {};
    this._scan();
    var form = this._canonicalForm;
    if (form) {
      try {
        var inputs = form.querySelectorAll('[name^="filter."]');
        inputs.forEach(function (inp) {
          try {
            if (inp.type === 'checkbox' || inp.type === 'radio') {
              inp.checked = false;
            } else if (inp.tagName === 'SELECT') {
              inp.selectedIndex = 0;
            } else if ('value' in inp) {
              inp.value = '';
            }
          } catch (e) { }
        });
      } catch (e) { }
    }

    // ensure quicklinks reflect cleared state
    try { this.syncQuickLinkUIFromForms(); } catch (e) { }

    // trigger reload once using controller's canonical serialization
    try {
      this.syncAndReload(options);
    } catch (e) {
      // fallback: naive reload to collection root
      var path = window.location.pathname;
      if (options && options.pushState === false) window.history.replaceState({ path: path }, '', path); else window.location.href = path;
    }
  };

  /**
   * Remove a specific filter param/value from the canonical form(s) and reload.
   * This is intended to be used by 'remove tag' UI controls which carry
   * data-filter-param and data-filter-value attributes.
   */
  FilterController.prototype.removeParamValue = function (paramName, value, options) {
    options = options || {};
    this._scan();
    // Normalize value: data attributes may contain url-encoded strings (spaces as + or %20).
    var rawValue = value || '';
    var normalized = rawValue.replace(/\+/g, ' ');
    try {
      normalized = decodeURIComponent(normalized);
    } catch (e) {
      // ignore decode errors and keep normalized
    }

    var found = false;
    // Query by name only, then match against decoded/normalized values to handle encoding differences
    var nameSelector = '[name="' + cssEscape(paramName) + '"]';
    [this.formDrawer, this.formSidebar, this.formQuick].forEach(function (form) {
      if (!form) return;
      try {
        var inputs = form.querySelectorAll(nameSelector);
        if (!inputs) return;
        Array.prototype.forEach.call(inputs, function (inp) {
          try {
            var inpValue = inp.value || '';
            // normalize input value for comparison
            var inpNorm = ('' + inpValue).replace(/\+/g, ' ');
            try { inpNorm = decodeURIComponent(inpNorm); } catch (e) { }

            if (inpNorm !== normalized) return;

            if (inp.type === 'checkbox' || inp.type === 'radio') {
              inp.checked = false;
            } else if (inp.tagName === 'SELECT') {
              inp.selectedIndex = 0;
            } else if ('value' in inp) {
              inp.value = '';
            }
            found = true;
            var ev = new Event('change', { bubbles: true });
            inp.dispatchEvent(ev);
          } catch (e) { }
        });
      } catch (e) { }
    });

    try { this.syncQuickLinkUIFromForms(); } catch (e) { }

    if (found) {
      try { this.syncAndReload(options); } catch (e) { /* swallow */ }
    }

    return !!found;
  };

  function cssEscape(s) { return (s + '').replace(/(["'\\])/g, '\\$1'); }

  window.theme = window.theme || {};
  window.theme.FilterController = FilterController;
  try { console.log('[FilterController] registered'); } catch (e) { }

})();
